import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, throwError, timer } from "rxjs";
import { retry } from "rxjs/operators";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class RetryInterceptor implements HttpInterceptor {

  // Retry for 30 seconds
  retryDelay = 2000;
  retryAttempts = 15;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        this.retryAfterDelay(),
      );
  }

  retryAfterDelay(): any {
    return retry({
      delay: (err, count) => {
        const currentAttempt = count;

        if (currentAttempt >= this.retryAttempts) {
          return throwError(() => err);
        }

        if (err.status === 0 || (err.status >= 500 && err.status <= 599)) {
          console.log(`Http error=${err.status} in ${err.url}. Retry=${currentAttempt}/${this.retryAttempts}`);

          return timer(this.retryDelay * currentAttempt);
        }

        return throwError(() => err);
      }
    });


  }
}

